// extracted by mini-css-extract-plugin
module.exports = {"shareGroupPopup":"src-components-Share-GroupPopup-styles-style-module__shareGroupPopup--1jYWS","content":"src-components-Share-GroupPopup-styles-style-module__content--1cXbP"};